import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonFunctionService ,UserMerchantData} from '../Common/common-function.service';
import { VposAdvancedQuickPayServicesViewModel } from 'src/app/models/vpos-advanced-quick-pay-services-view-model';
import { VposQuickPayAppView } from 'src/app/models/vpos-quick-pay-app-view';
import { VposQuickPayTransactionResponse } from 'src/app/models/vpos-quick-pay-transaction-response';
import { catchError, map } from 'rxjs';
import { StringIterator } from 'lodash';
export interface JsonAddSplitDetails {

  // serviceName: string,

  amount: number,

  venderId: number

}

@Injectable()
export class QuickpayService {
  userId: any;
  token;
  headers: any;
  fromdate1: string;
  todate1: string;

  constructor(private service: DataService,private http: HttpClient, private common:CommonFunctionService) {
    let loggedUsername =this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
    }
  AddQuickPaySettings(data,email)
  {  
    this.GetHeaderdetails(); 
    return this.http.post<VposQuickPayAppView>(environment.AddQuickPaySettingsUrl+"?Email="+email, data, { headers:this.headers });
  }

  GetQuickPay(merchantKeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView>(environment.GetQuickPayUrl+'?merchantKeyId='+merchantKeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers });
}
GetQuickPaySettings(merchantKeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView>(environment.ManageQuickPayUrl+'?merchantKeyId='+merchantKeyId+ "&LoginUserId="+merchantdata.UserId)
  .pipe(map(response => response),catchError(this.common.handleError));
}

getQuickPayDetailsById(data,merchantkeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView>(environment.ViewQuickPayDetailsUrl+"?Id="+data+"&MerchantKeyId="+merchantkeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers })  
  .pipe(map(response => response),catchError(this.common.handleError));
} 
editQuickPayData(data,quickPayId)
{
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  this.GetHeaderdetails();
  return this.http.put(environment.editQuickPayDataUrl + '?QuickPayId='+quickPayId+"&MerchantKeyId="+merchantdata.MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
  , data, { headers:this.headers });
}
deleteQuickPayData(quickPayId,data)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.put(environment.deleteQuickPayDataUrl + '?QuickPayId='+quickPayId+"&MerchantKeyId="+merchantdata.MerchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , data, { headers:this.headers });
}

deleteAdvancedServiceData(serviceId,data)
{
    return this.http.put(environment.deleteAdvancedServiceDataUrl + '?QuickPayServiceId='+serviceId, data, { headers:this.headers });
}
checkDuplicteQuickCode(quickCode,merchantkeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView[]>(environment.checkDuplicateQuickCodeUrl+"?QuickCode="+quickCode+"&MerchantKeyId="+merchantkeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers })  
  .pipe(map(response => response),catchError(this.common.handleError));
}
checkDuplicteServiceName(serviceName,merchantkeyId,quickCode)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposAdvancedQuickPayServicesViewModel[]>(environment.checkDuplicateServiceNameUrl+"?ServiceName="+serviceName+"&MerchantKeyId="+merchantkeyId+"&QuickCode="+quickCode+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers })  
  .pipe(map(response => response),catchError(this.common.handleError));
}
createAdvancedQuickPay(data,email)
{  
  this.GetHeaderdetails(); 
  return this.service.create(environment.createAdvancecQuickPayUrl+"?Email="+email, data);
}

AddQuickPayService(data,email)
{  
  this.GetHeaderdetails(); 
  return this.http.post(environment.addAdvancedQuickPayServiceUrl+"?Email="+email, data, { headers:this.headers });
}

GetAdvancecQuickPayServicesList(merchantKeyId,quickPay)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposAdvancedQuickPayServicesViewModel>(environment.getAdvancedQuickPayServicesUrl+'?merchantKeyId='+merchantKeyId+"&QuickPayId="+quickPay+ "&LoginUserId="+merchantdata.UserId);
}
getQuickPayTransactions(quickpaycode,merchantkeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView>(environment.QuickPayTransactionUrl+"?Id="+quickpaycode+"&MerchantKeyId="+merchantkeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers })  
  .pipe(map(response => response),catchError(this.common.handleError));
} 


getQuickPayTransactionDetails(id,merchantkeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayTransactionResponse>(environment.getQuickPayTransactionDetailsUrl+"?Id="+id+"&MerchantKeyId="+merchantkeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers })  
  .pipe(map(response => response),catchError(this.common.handleError));
} 

ManageQuickPayUrl(merchantKeyId)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<VposQuickPayAppView>(environment.ManageQuickPayUrl+'?merchantKeyId='+merchantKeyId+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers})
  .pipe(map(response => response),catchError(this.common.handleError));
}

getFilterQuickPaytransactiondetails(MerchantKeyId,Fromdate1,todate1,
  transactionid,Amount,amountcompare,email,quickpaycode)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getFilterQuickPaytransactiondetails + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
     + "&TransactionId=" + transactionid + "&Amount=" + Amount + "&AmountCheck=" + amountcompare + "&Email=" + email+ "&Code="+quickpaycode+ "&LoginUserId="+merchantdata.UserId
     , { headers:this.headers });
}
getAdvancedQuickPayServicesUrl(MerchantKeyId,advancedQuickpayid)
{
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  return this.http.get<any>( environment.getAdvancedQuickPayServicesUrl + '?merchantKeyId=' + MerchantKeyId + "&QuickPayId=" + advancedQuickpayid+ "&LoginUserId="+merchantdata.UserId
  , { headers:this.headers });

}
QuickPayFilterdataUrl(MerchantKeyId,txtQuickPayId,Fromdate1,todate1,txtUsername,txtQuickCodeId,
  quickPayType,txtQuestion1,txtQuestion2,txtQuestion3)
  {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(  environment.QuickPayFilterdataUrl + "?MerchantKeyId=" + MerchantKeyId + "&Id=" + txtQuickPayId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&UserName=" + txtUsername
      + "&QuickCode=" + txtQuickCodeId + "&quickPayType=" + quickPayType + "&Question1=" + txtQuestion1 + "&Question2=" + txtQuestion2 + "&Question3=" + txtQuestion3+ "&LoginUserId="+merchantdata.UserId
      , { headers:this.headers });


  }
  
 GetHeaderdetails()
 {
   let loggedUsername =this.common.getUserName()
   const merchantdata: UserMerchantData = this.common.getUserMerchantData();
   this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
   this.headers = new HttpHeaders().
   set('Authorization', 'basic ' + btoa(this.token));


 }
 getvendordetails(data) {
  this.GetHeaderdetails();
  const merchantdata: UserMerchantData = this.common.getUserMerchantData();
  data.MerchantKeyId = merchantdata.MerchantKeyId;
  let loggedUsername = this.common.getUserName()
  this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
  this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  // return this.http.get<any>( environment.getSettlementVendorList+"?MerchantKeyId="+data.MerchantKeyId,{ headers:this.headers});
  
  const today = new Date();

  // const tomorrow = new Date(2000,1,1).toISOString().slice(0, 10);



  this.fromdate1 = '2000-01-01';

  this.todate1 = new Date(today).toISOString().slice(0, 10);
  
  return this.http.get<any>( environment.viewvendorFilterdataurl+"?MerchantKeyId="+data.MerchantKeyId+ "&fromdate=" + this.fromdate1 + "&todate=" + this.todate1+ "&Email=" + ""
  + "&VendorId=" + "" + "&VendorName=" + "" + "&Mobile=" + "" + "&VendorType=" + "" + "&UserId=" + "null",{ headers:this.headers});

}
}

